import React, { useEffect, useRef, useState } from 'react';
import { getDatabase, ref, child, set as firebaseSet, onValue, remove as firebaseRemove, push as firebasePush } from 'firebase/database';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { Routes, Route, useLocation } from 'react-router-dom';

import { Navigation, Footer, Spinner, wrapEmail } from './components/Globals';
import Home from './components/pages/Home';
import Book from './components/pages/Book';
import Author from './components/pages/Author';
import Events from './components/pages/Events';
import Media from './components/pages/Media';
import Originals from './components/pages/Originals';
import Reviews from './components/pages/Reviews';
import Contact from './components/pages/Contact';
import Data from './components/pages/Data';
import Unsubscribe from './components/pages/Unsubscribe';
import Proof from './components/pages/Proof';
import Exclusive from './components/pages/Exclusive';

function ScrollToTop({ scrollRef }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (scrollRef?.current) {
      scrollRef.current.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [pathname]);

  return null;
}

function App() {
  const [eventLog, setEventLog] = useState();
  const [mediaLog, setMediaLog] = useState();
  const [reviewLog, setReviewLog] = useState();
  const [newsletterLog, setNewsletterLog] = useState();
  const [emailLog, setEmailLog] = useState();
  const [requestLog, setRequestLog] = useState();

  const [isFetching, setIsFetching] = useState(true);

  const [showConfirmMessage, setConfirmMessage] = useState(null);

  const [showSubAlert, setSubAlert] = useState(null);
  const [subAlertMessage, setSubAlertMessage] = useState(null);
  const [subAlertType,setSubAlertType] = useState(null);

  const [showUnsubAlert, setUnsubAlert] = useState(null);
  const [unsubAlertMessage, setUnsubAlertMessage] = useState(null);
  const [unsubAlertType,setUnsubAlertType] = useState(null);
  const [unsubComplete, setUnsubComplete] = useState(null);

  const [showConfirmProof, setConfirmProof] = useState(null);
  const [proofMessage, setProofMessage] = useState(null);

  const scrollRef = useRef(null);

  function updateConfirmMessage() {
    setConfirmMessage("");
  }

  function updateSubAlert() {
    setSubAlert("");
  }

  function updateUnsubAlert() {
    setUnsubAlert("");
  }

  function updateConfirmProof() {
    setConfirmProof("");
  }

  function updateEvents(newEvent, transType, eventKey) {
    const db = getDatabase();
    let eventRef = "";
    let newLog = [];

    if (transType === "add") {
      eventRef = ref(db, 'creatorData/events');
      const key = firebasePush(eventRef, newEvent).key;
      newLog = [...eventLog].concat({...newEvent, "key": key});
    } else {
      eventRef = ref(db, 'creatorData/events/' + eventKey)
      if (transType === "remove") {
        firebaseRemove(eventRef);
        newLog = eventLog.filter((event) => event.key !== eventKey);
      } else { //transType === "set"
        firebaseSet(eventRef, newEvent);
        newLog = eventLog.map((event) => {
          if (event.key === eventKey) {
            event.name = newEvent.name;
            event.date = newEvent.date;
            event.location = newEvent.location;
            event.description = newEvent.description;
            event.image = newEvent.image;
            event.preLink = newEvent.preLink;
            event.postLink = newEvent.postLink;
            event.isFeatured = newEvent.isFeatured;
          }
          return event;
        });
      }
    }
    setEventLog(newLog);
  }

  function updateMedia(newMedia, transType, mediaKey) {
    const db = getDatabase();
    let mediaRef = "";
    let newLog = [];

    if (transType === "add") {
      mediaRef = ref(db, 'creatorData/media');
      const key = firebasePush(mediaRef, newMedia).key;
      newLog = [...mediaLog].concat({...newMedia, "key": key});
    } else {
      mediaRef = ref(db, 'creatorData/media/' + mediaKey)
      if (transType === "remove") {
        firebaseRemove(mediaRef);
        newLog = mediaLog.filter((media) => media.key !== mediaKey);
      } else { //transType === "set"
        firebaseSet(mediaRef, newMedia);
        newLog = mediaLog.map((media) => {
          if (media.key === mediaKey) {
            media.name = newMedia.name;
            media.date = newMedia.date;
            media.type = newMedia.type;
            media.format = newMedia.format;
            media.program = newMedia.program;
            media.host = newMedia.host;
            media.description = newMedia.description;
            media.image = newMedia.image;
            media.link = newMedia.link;
            media.isFeatured = newMedia.isFeatured;
          }
          return media;
        });
      }
    }
    setMediaLog(newLog);
  }

  function updateReviews(newReview, transType, reviewKey) {
    const db = getDatabase();
    let reviewRef = "";
    let newLog = [];

    if (transType === "add") {
      reviewRef = ref(db, 'creatorData/reviews');
      const key = firebasePush(reviewRef, newReview).key;
      newLog = [...reviewLog].concat({...newReview, "key": key});
    } else {
      reviewRef = ref(db, 'creatorData/reviews/' + reviewKey)
      if (transType === "remove") {
        firebaseRemove(reviewRef);
        newLog = reviewLog.filter((review) => review.key !== reviewKey);
      } else { //transType === "set"
        firebaseSet(reviewRef, newReview);
        newLog = reviewLog.map((review) => {
          if (review.key === reviewKey) {
            review.reviewer = newReview.reviewer;
            review.order = newReview.order;
            review.cred = newReview.cred;
            review.image = newReview.image;
            review.quote = newReview.quote;
            review.isFeatured = newReview.isFeatured;
          }
          return review;
        });
      }
    }
    setReviewLog(newLog);
  }

  // function updateNewsletter(newLetter) {
  //   const db = getDatabase();
  //   const newsletterRef = ref(db, 'creatorData/newsletters');
  //   firebasePush(newsletterRef, newLetter);

  //   // const newLog = [...reviewLog].concat(newReview);
  //   // setReviewLog(newLog);

  // }

  async function updateNewsletter(newLetter, transType, letterKey) {
    const rtdb = getDatabase();
    let newsletterRef = "";
    let newLog = [];

    if (transType === "send" || transType === "save") {
      newsletterRef = ref(rtdb, 'creatorData/newsletters');

      firebasePush(newsletterRef, newLetter);
      const key = firebasePush(newsletterRef, newLetter).key;
      newLog = [...newsletterLog].concat({...newLetter, "key": key});

      if (transType === "send") {
        const db = getFirestore(); // Initialize Firestore
        try {
            // Reference the "mail" collection
            const mailCollection = collection(db, 'mail');

            // Add a new document to the "mail" collection
            const docRef = await addDoc(mailCollection, newLetter);

            console.log('Document written with ID: ', docRef.id);
        } catch (error) {
            console.error('Error adding document: ', error);
        }
      }
    } else {
      newsletterRef = ref(rtdb, 'creatorData/newsletters/' + letterKey);
      if (transType === "remove") {
        firebaseRemove(newsletterRef);
        newLog = newsletterLog.filter((letter) => letter.key !== letterKey);
      } else { //transType === "set"
        firebaseSet(newsletterRef, newLetter);
        newLog = newsletterLog.map((letter) => {
          if (letter.key === letterKey) {
            letter.message = newLetter.message;
          }
          return letter;
        });
      }
    }
    setNewsletterLog(newLog);   
  }

  // temp one
  // function updateMedia(newMedia, transType, mediaKey) {
  //   const db = getDatabase();
  //   let mediaRef = "";
  //   let newLog = [];

  //   if (transType === "add") {
  //     mediaRef = ref(db, 'creatorData/media');
  //     const key = firebasePush(mediaRef, newMedia).key;
  //     newLog = [...mediaLog].concat({...newMedia, "key": key});
  //   } else {
  //     mediaRef = ref(db, 'creatorData/media/' + mediaKey)
  //     if (transType === "remove") {
  //       firebaseRemove(mediaRef);
  //       newLog = mediaLog.filter((media) => media.key !== mediaKey);
  //     } else { //transType === "set"
  //       firebaseSet(mediaRef, newMedia);
  //       newLog = mediaLog.map((media) => {
  //         if (media.key === mediaKey) {
  //           media.name = newMedia.name;
  //           media.date = newMedia.date;
  //           media.type = newMedia.type;
  //           media.format = newMedia.format;
  //           media.program = newMedia.program;
  //           media.host = newMedia.host;
  //           media.description = newMedia.description;
  //           media.image = newMedia.image;
  //           media.link = newMedia.link;
  //         }
  //         return media;
  //       });
  //     }
  //   }
  //   setMediaLog(newLog);
  // }
  
  async function addEmails(newEmail) {
    const db = getDatabase();
    const emailRef = ref(db, 'userData/emails');
    let isNew = true;

    // verify email is in list
    for (const email of emailLog) {
      if (email.email.toLowerCase() === newEmail.email.toLowerCase()) {
          isNew = false;
      }
    }
    
    if (isNew) {
      firebasePush(emailRef, newEmail);
      setSubAlertMessage("Thanks for subscribing!")
      setSubAlertType('success');

      const newLog = [...emailLog].concat(newEmail);
      setEmailLog(newLog);

      const db = getFirestore(); // Initialize Firestore
      try {
          // Reference the "mail" collection
          const mailCollection = collection(db, 'mail');

          // Add a new document to the "mail" collection
          const subject = 'Welcome to "Our Next Reality"';
          const message = `
                <h1 style="font-family: Times New Roman, serif; font-weight: 400;">Thanks for Your Interest in <em>Our Next Reality!</em></h1>

                <p>As a <strong>special thank you</strong> for your support, we would like to give our subscribers the opportunity to access the <strong>high-quality color version of the book's figures and photos.</strong></p>

                <p>If you bought any version of <em>Our Next Reality</em>, please fill out this 
                  <a style="color:#ec8f73;" href="http://ournextreality.com/pop" target="_blank">form</a>
                  to upload proof of your purchase.
                </p>

                <h2 style="font-family: Times New Roman, serif; font-weight: 400;">The eBook and Audiobook Formats Are Released Globally!</h2>

                <div style="text-align:center;">
                  <img src="https://firebasestorage.googleapis.com/v0/b/agraylin-site.appspot.com/o/newsletterImages%2FOur%20Next%20Reality%20formats.png?alt=media&token=6a72106b-e656-4c5a-85c1-413642a123b8"
                      style="max-width:100%; height:auto;" />
                </div>

                <p><span style="font-family: Times New Roman, serif;">Much Appreciated,</span><br/>Alvin and Louis</p>
      `;
          const wrappedMessage = wrapEmail(message);

          // const message = '<figure><img src="https://firebasestorage.googleapis.com/v0/b/agraylin-site.appspot.com/o/newsletterImages%2FOur%20Next%20Reality%20logo.PNG?alt=media&token=26815693-dad6-4f1e-8b03-6a85f3c4bf1c" alt="" /></figure><p></p><h1><strong>Thanks for Your Interest in <em>Our Next Reality!</em></strong></h1><p>As a <strong>special thank you</strong> for your support, we would like to give our subscribers the opportunity to access the <strong>high-quality color version of the book&#x27;s figures and photos.</strong></p><p>If you bought any version of <em>Our Next Reality</em>, please fill out this <u><a href="http://ournextreality.com/pop" target="_blank" rel="noopener noreferrer">form</a></u> to upload proof of your purchase, and you&#x27;ll receive a download link to the HD graphics file. We hope this will help improve your reading experience. Enjoy the book!</p><p>If you have time, we would appreciate your help in posting a <u>written review</u> on the platform you purchased from and/or on <u><a href="https://www.goodreads.com/book/show/199615607-our-next-reality" target="_blank" rel="noopener noreferrer">Goodreads</a></u>. 🙏</p><h2><strong>The eBook and Audiobook Formats Are <u>Released</u> Globally!</strong></h2><p>Available on Amazon (<u><a href="https://www.amazon.com/dp/1399812246/ref=cm_sw_r_as_gl_api_gl_i_CWSY31NM2VZ2AH3GHH04?linkCode=ml1&tag=tag02b-20" target="_blank" rel="noopener noreferrer">Kindle</a></u>/<u><a href="https://www.audible.com/pd/Our-Next-Reality-Audiobook/B0CLD7DW5D" target="_blank" rel="noopener noreferrer">Audible</a></u>) and Apple (<u><a href="https://books.apple.com/us/book/our-next-reality/id6469685058" target="_blank" rel="noopener noreferrer">Books</a></u>/<u><a href="https://books.apple.com/us/audiobook/our-next-reality/id1724319743" target="_blank" rel="noopener noreferrer">Audiobooks</a></u>) platforms. The <u><a href="https://www.amazon.com/dp/1399812246/ref=cm_sw_r_as_gl_api_gl_i_CWSY31NM2VZ2AH3GHH04?linkCode=ml1&tag=tag02b-20" target="_blank" rel="noopener noreferrer">hardcover</a></u> version will be released in offline and ecommerce stores on June 4th.</p><figure><img src="https://firebasestorage.googleapis.com/v0/b/agraylin-site.appspot.com/o/newsletterImages%2FOur%20Next%20Reality%20formats.png?alt=media&token=6a72106b-e656-4c5a-85c1-413642a123b8" alt="" style="max-width: 100%" /></figure><p></p><p><strong>Much Appreciated,</strong></p><p>Alvin and Louis </p><br><hr><div style="text-align: center;"><u><a href="http://ournextreality.com" target="_blank" rel="noopener noreferrer">OurNextReality.com</a></u></div><div style="text-align: center;">You are receiving this email because you signed up for the mailing list.</div><div style="text-align: center;"><u><a href="http://ournextreality.com/unsubscribe" target="_blank" rel="noopener noreferrer">Unsubscribe</a></u> | <u><a href="http://ournextreality.com/contact" target="_blank" rel="noopener noreferrer">Contact</a></u></div><div style="text-align: center;">©2024 A. Graylin. All rights reserved.</div>';
          // const message = '<figure><img src="https://firebasestorage.googleapis.com/v0/b/agraylin-site.appspot.com/o/newsletterImages%2FOur%20Next%20Reality%20logo.PNG?alt=media&token=26815693-dad6-4f1e-8b03-6a85f3c4bf1c" alt="" style="max-width: 100%" /></figure><h1><strong>Thank You for Your Support!</strong></h1><p>We really appreciate you buying a copy of <em>Our Next Reality</em>. If you have the time, please continue to support us by writing a review on the platform you purchased from.</p><p>You can access the high quality graphics to supplement your reading <u><a href="http://ournextreality.com/exclusub" target="_blank" rel="noopener noreferrer">here</a></u>.</p><p></p><p><br><strong>Happy Reading!</strong></p><p>Alvin and Louis</p>';
          const emailContent = {"to": newEmail.email, "message": {"subject": subject, "html": wrappedMessage}};
          // "from": "Our Next Reality Team <info@ournextreality.com>",
          const docRef = await addDoc(mailCollection, emailContent);

          console.log('Document written with ID: ', docRef.id);
      } catch (error) {
          console.error('Error adding document: ', error);
      }
    } else {
      setSubAlertMessage("This email is already on our list.");
      setSubAlertType('warning');
    }    
    
    setSubAlert(true);

    // original
    // firebasePush(emailRef, newEmail);

    // const newLog = [...emailLog].concat(newEmail);
    // setEmailLog(newLog);
    // setConfirmSignup(true);
  }

  function removeEmails(unsubEmail) {
    const db = getDatabase();
    const unsubRef = ref(db, 'userData/unsubscribed/');
    let emailToRemoveRef = null;
    let key = null;

    // verify email is in list
    for (const email of emailLog) {
      if (email.email.toLowerCase() === unsubEmail.email.toLowerCase()) {
          key = email.key;
      }
    }
    
    emailToRemoveRef = ref(db, 'userData/emails/' + key);
    if (key) {
      firebaseRemove(emailToRemoveRef)
      .then(() => {
        setUnsubAlertMessage("We're sorry to see you go. Your email has been removed from the list.")
        setUnsubAlertType('success');
        setUnsubComplete(true);
        firebasePush(unsubRef, unsubEmail);
      })
      .catch((err) => {
        setUnsubAlertMessage("Error in the system. Try again later.");
        setUnsubAlertType('danger');
      });      
    } else {
      setUnsubAlertMessage("Error. This email is not on our list.");
      setUnsubAlertType('danger');
    }    
    // const newLog = [...emailLog].concat(newEmail);
    // setEmailLog(newLog);
    setUnsubAlert(true);
  }

  async function updateProofs(newProof) {
    const rtdb = getDatabase();
    const proofRef = ref(rtdb, 'userData/proofs');
    firebasePush(proofRef, newProof);

    let isNew = true;

    // verify email is in list
    for (const email of emailLog) {
      if (email.email.toLowerCase() === newProof.email.toLowerCase()) {
          isNew = false;
      }
    }

    if (isNew) {
      const today = new Date().toISOString().substring(0, 10);
      const emailRef = ref(rtdb, 'userData/emails');
      const newEmail = {"date": today, "email": newProof.email};
      firebasePush(emailRef, newEmail);
      setProofMessage("Thanks for purchasing Our Next Reality! An email will be sent shortly with directions for accessing the graphics. You have also been added to the mailing list.");
    } else {
      setProofMessage("Thanks for purchasing Our Next Reality! An email will be sent shortly with directions for accessing the graphics.");
    }

    setConfirmProof(true);

    const db = getFirestore(); // Initialize Firestore
    try {
        // Reference the "mail" collection
        const mailCollection = collection(db, 'mail');

        // Add a new document to the "mail" collection
        // const subject = "Enjoy HD Graphics from Our Next Reality";
        const subject = "Get Access to HD Graphics from Our Next Reality";
        const message = `
              <h1 style="font-family: Times New Roman, serif; font-weight: 400;">Thank You for Your Support!</em></h1>
              <p>We really appreciate you buying a copy of <em>Our Next Reality</em>. If you have time, please continue to support us by <u>writing a review</u> on the platform you purchased from and/or on <u><a style="color:#ec8f73;" href="https://www.goodreads.com/book/show/199615607-our-next-reality" target="_blank" rel="noopener noreferrer">Goodreads</a></u>.</p>
              <p>You can access the high quality graphics to supplement your reading <u><a style="color:#ec8f73;" href="http://ournextreality.com/exclusub" target="_blank" rel="noopener noreferrer">here</a></u>.</p>
              <p><em>Note: Please do not distribute or post the figures without written permission.</em></p>

              <br/>
              <p><span style="font-family: Times New Roman, serif;">Happy Reading,</span><br/>Alvin and Louis</p>
        `;
        const wrappedMessage = wrapEmail(message);

        // original message
        // const message = '<figure><img src="https://firebasestorage.googleapis.com/v0/b/agraylin-site.appspot.com/o/newsletterImages%2FOur%20Next%20Reality%20logo.PNG?alt=media&token=26815693-dad6-4f1e-8b03-6a85f3c4bf1c" alt="" /></figure><p></p><h1><strong>Thank You for Your Support!</strong></h1><p>We really appreciate you buying a copy of <em>Our Next Reality</em>. If you have time, please continue to support us by <u>writing a review</u> on the platform you purchased from and/or on <u><a href="https://www.goodreads.com/book/show/199615607-our-next-reality" target="_blank" rel="noopener noreferrer">Goodreads</a></u>.</p><p>You can access the high quality graphics to supplement your reading <u><a href="http://ournextreality.com/exclusub" target="_blank" rel="noopener noreferrer">here</a></u>.</p><p><em>Note: Please do not distribute or post the figures without written permission.</em></p><br><p><strong>Happy Reading,</strong></p><p>Alvin and Louis</p>';
        // const message = '<figure><img src="https://firebasestorage.googleapis.com/v0/b/agraylin-site.appspot.com/o/newsletterImages%2FOur%20Next%20Reality%20logo.PNG?alt=media&token=26815693-dad6-4f1e-8b03-6a85f3c4bf1c" alt="" style="max-width: 100%" /></figure><h1><strong>Thank You for Your Support!</strong></h1><p>We really appreciate you buying a copy of <em>Our Next Reality</em>. If you have the time, please continue to support us by writing a review on the platform you purchased from.</p><p>You can access the high quality graphics to supplement your reading <u><a href="http://ournextreality.com/exclusub" target="_blank" rel="noopener noreferrer">here</a></u>.</p><p></p><p><br><strong>Happy Reading!</strong></p><p>Alvin and Louis</p>';
        const emailContent = {"to": ["newProof.email"], "from": "Our Next Reality Team <info@ournextreality.com>", "message": {"subject": subject, "html": wrappedMessage}};
        const docRef = await addDoc(mailCollection, emailContent);

        console.log('Document written with ID: ', docRef.id);
    } catch (error) {
        console.error('Error adding document: ', error);
    }
  }

  function updateRequests(newReq) {
    const db = getDatabase();
    const requestRef = ref(db, 'userData/requests');
    firebasePush(requestRef, newReq);

    const newLog = [...requestLog].concat(newReq);
    setRequestLog(newLog);
    setConfirmMessage(true);
    sendRequestConfirmation(newReq);
  }

  async function sendRequestConfirmation(newReq){
    const today = new Date().toISOString().substring(2, 10);
    let confirmationNo = today.replace(/\D/g, '');
    confirmationNo = "10"+confirmationNo;

    const db = getFirestore(); // Initialize Firestore
    try {
        // Reference the "mail" collection
        const mailCollection = collection(db, 'mail');
        const message = `
        <p>Name: ${newReq.name}</p>
        <p>Email: ${newReq.email}</p>
        <p>Subject: ${newReq.subject}</p>
        <br/>
        <p>Message:</p><p>${newReq.html}</p>
        `;

        const wrappedMessage = wrapEmail(message, false);
        // Add a new document to the "mail" collection
        const docRef = await addDoc(mailCollection, 
          {"to": [newReq.email], "bcc": ["support@ournextreality.com"], "from": "Our Next Reality Team <info@ournextreality.com>", "message": {
            "subject": "[#"+confirmationNo+"] "+newReq.subject, 
            "html": wrappedMessage}}
        );

        // original html content
        // '<figure><img src="https://firebasestorage.googleapis.com/v0/b/agraylin-site.appspot.com/o/newsletterImages%2FOur%20Next%20Reality%20logo.PNG?alt=media&token=26815693-dad6-4f1e-8b03-6a85f3c4bf1c" alt="" /></figure><p>Name: '+newReq.name+"</p><p>Email: "+newReq.email+"</p><p>Subject: "+newReq.subject+"</p><br><p>Message:</p><p>"+newReq.html+"</p>"

        console.log('Document written with ID: ', docRef.id);
    } catch (error) {
        console.error('Error adding document: ', error);
    }
    return null;
  }


  const db = getDatabase();
  const creatorDataRef = ref(db, 'creatorData/');
  useEffect(() => {
    setIsFetching(true);
    onValue(creatorDataRef, (snapshot) => {
      const data = snapshot.val();

      const events = Object.keys(data.events)?.map(key => {
        const singleLog = { ...data.events[key] };
        singleLog.key = key;
        return singleLog;
      });
      setEventLog(events);

      const media = Object.keys(data.media)?.map(key => {
        const singleLog = { ...data.media[key] };
        singleLog.key = key;
        return singleLog;
      });
      setMediaLog(media);

      const reviews = Object.keys(data.reviews)?.map(key => {
        const singleLog = { ...data.reviews[key] };
        singleLog.key = key;
        return singleLog;
      });
      setReviewLog(reviews);

      const newsletters = Object.keys(data.newsletters)?.map(key => {
        const singleLog = { ...data.newsletters[key] };
        singleLog.key = key;
        return singleLog;
      });
      setNewsletterLog(newsletters);
      setIsFetching(false);
    })
  }, []);
    
  const userDataRef = ref(db, 'userData/');
  useEffect(() => {
    setIsFetching(true);
    onValue(userDataRef, (snapshot) => {
      const data = snapshot.val();
  
      const emails = Object.keys(data.emails)?.map(key => {
        const singleLog = { ...data.emails[key] };
        singleLog.key = key;
        return singleLog;
      });
      setEmailLog(emails);

      const requests = Object.keys(data.requests)?.map(key => {
        const singleLog = { ...data.requests[key] };
        singleLog.key = key;
        return singleLog;
      });
      setRequestLog(requests);
      setIsFetching(false);
    })
  }, []);

  return (
    <>
      <div ref={scrollRef} style={{ overflowY: "auto", height: "100vh", height: "100dvh", overflowX: "hidden", width:"100%" }}>
      <Navigation />
      <ScrollToTop scrollRef={scrollRef} />
      <Routes>
        <Route path="/" element={<Home isFetching={isFetching} events={eventLog} media={mediaLog} reviews={reviewLog} emailCallback={addEmails} showConfirm={showSubAlert} alertType={subAlertType} showConfirmMessage={subAlertMessage} showConfirmCallback={updateSubAlert}/>} />
        <Route path="book" element={<Book isFetching={isFetching} reviews={reviewLog}/>} />
        <Route path="author" element={<Author />} />
        <Route path="events" element={<Events isFetching={isFetching} events={eventLog}/>} />
        <Route path="media" element={<Media isFetching={isFetching} media={mediaLog}/>} />
        <Route path="originals" element={<Originals isFetching={isFetching} media={mediaLog} />} />
        <Route path="reviews" element={<Reviews isFetching={isFetching} reviews={reviewLog}/>} />
        <Route path="contact" element={<Contact requestCallback={updateRequests} showConfirm={showConfirmMessage} showConfirmCallback={updateConfirmMessage}/>} />

        <Route path="adddata" element={<Data isFetching={isFetching} events={eventLog} media={mediaLog} reviews={reviewLog} newsletters={newsletterLog} emails={emailLog} eventCallback={updateEvents} reviewCallback={updateReviews} newsletterCallback={updateNewsletter} mediaCallback={updateMedia}/>} />
        <Route path="unsubscribe" element={<Unsubscribe unsubCallback={removeEmails} isSubmitted={unsubComplete} showConfirm={showUnsubAlert} alertType={unsubAlertType} showConfirmMessage={unsubAlertMessage} showConfirmCallback={updateUnsubAlert}/>} />
        <Route path="pop" element={<Proof proofCallback={updateProofs} showConfirm={showConfirmProof} showConfirmMessage={proofMessage} showConfirmCallback={updateConfirmProof}/>} />
        <Route path="exclusub" element={<Exclusive isFetching={isFetching} />} />
        
        <Route path="*" element={<Home isFetching={isFetching} events={eventLog} media={mediaLog} reviews={reviewLog} emailCallback={addEmails} showConfirm={showSubAlert} alertType={subAlertType} showConfirmMessage={subAlertMessage} showConfirmCallback={updateSubAlert}/>} />
      </Routes>
      {isFetching ? <Spinner /> : ''}
      <Footer />
      </div>
    </>
  );
}

export default App;
